<template>
  <!-- 预渲染使用 不要删除 app 的div-->
  <div id="app">
    <!-- <cpp /> -->
    <architect />
  </div>
</template>

<script>
// import cpp from './pages/cpp'
import architect from './pages/architect'

export default {
  name: 'App',
  components: {
    // cpp
    architect
  },
  mounted() {
  },
  metaInfo: {
    // title: 'C/C++培训_北京C++培训_好口碑C/C++培训机构-传智教育',
    title: '架构师培训_软件架构师培训_狂野架构师线上培训班-传智教育',
    meta: [
      {
        name: 'Keywords',
        // content: 'C语言培训,C++培训,C语言线上培训,C++线上培训班'
        content: '架构师培训,软件架构师培训,架构师线上培训,架构师线上培训班'
      },
      {
        name: 'Description',
        // content: '传智教育(“传智播客”全新升级为“传智教育”)C/C++线上就业班，从底层技术到前沿开发一应俱全，5大企业级重磅项目支撑，基础知识+进阶技能全方位深入学习，成就企业“稀缺级”人才，轻松斩获Offer！'
        content: '传智教育(“传智播客”全新升级为“传智教育”)狂野架构师线上就业班，三大课程优势+7大领域真实项目演练，学精华实用架构技术，告别低效开发内卷，6个月进阶技术金领！'
      }
    ]
  },
}
</script>

<style lang="scss">
input {
  outline: none;
}
body,
html {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 10px;
}
ul,
p,
span,
h1,
h2,
h3,
h4,
h5,
h6,
i,
div {
  margin: 0;
  padding: 0;
  list-style: none;
  font-style: normal;
  // font-family: none;
}

#chatBtn {
  visibility: hidden;
}
.img-bottom {
  width: 100%;
  height: auto;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1000;
}
.paddingBottom {
  padding-bottom: 88px;
}
</style>
